// import React, { useEffect } from "react";
// import avtar from "../../assets/images/avtar.jpg";
// import { Link, useNavigate } from "react-router-dom";
// // import DeleteToast from "../Users/DeleteToast";
// import LogoutToast from "./LogoutToast";
// import PasswordReset from "./PasswordReset";
// export default function Header() {
//   let navigate = useNavigate();
//   // let [deleteid, setDeleteid] = useState();
//   // let [logout, setlogout] = useState(false);
//   let token = localStorage.getItem("token");

//   useEffect(() => {
//     if (!token) {
//       navigate("/login");
//     }
//   }, []);
//   let UserDetails = JSON.parse(localStorage.getItem("user"));

//   // console.log(UserDetails)
//   // manish@objectsquare.com
//   // let logoutfunction = () => {
//   //   localStorage.clear();
//   //   navigate("/Login");
//   // };
//   const removeClass = (e) => {
//     document?.body?.classList?.toggle("resize-menu");
//   };
//   const handleError = (e) => {
//     e.target.src = avtar;
//   };
//   return (
//     <>
//       <header className="header">
//         <div className="navbar-header">
//           <div className="row align-items-center">
//             <div className="col-lg-5 col-md-6 col-sm-6 col-6">
//               <div className="header-fltr">
//                 <Link to="" className="toggle fs-4" onClick={removeClass}>
//                   <i className="fa fa-bars" />
//                 </Link>
//                 <form action="">
//                   <div className="header-fltr-bx">
//                     {/* <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Type here..."
//                     />
//                     <span className="fa fa-search" /> */}
//                     {/* <div className="text-light fs-5">
//                   Youth Education — Education With Your Trust
//                   </div> */}
//                   </div>
//                 </form>
//               </div>
//             </div>
//             <div className="col-lg-7 col-md-6 col-sm-6 col-6">
//               <div className="app-header-right-side">
//                 {/* <ul className="app-header-right-side-list">
//                   <li>
//                     <Link to="">Help</Link>
//                   </li>
//                   <li>
//                     <button type="button" className="position-relative">
//                       <i className="fa fa-bell" />
//                       <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
//                         1
//                       </span>
//                     </button>
//                   </li>
//                 </ul> */}
//                 <div className="prfl-bar">
//                   <div className="prfl-bar-img">
//                     <img
//                       onError={handleError}
//                       src={`${UserDetails?.profile_image}`}
//                       className="profle"
//                       alt="profile_image"
//                     />
//                   </div>
//                   <div className="prfl-bar-content">
//                     <div className="dropdown">
//                       <button
//                         className="dropdown-toggle"
//                         type="button"
//                         id="profile-menu"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         <span>
//                           {UserDetails?.name}
//                         </span>
//                       </button>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="profile-menu"
//                       >
//                         <li>
//                           <Link
//                             data-bs-toggle="modal"
//                             data-bs-target="#logout"
//                           >
//                             <i className="fa fa-sign-out me-2" />
//                             Signout
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//       <LogoutToast />
//       <PasswordReset />
//     </>
//   );
// }

import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Header() {
  let navigate = useNavigate();
  let token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  const removeClass = (e) => {
    document?.body?.classList?.toggle("resize-menu");
  };

  // ✅ Direct logout handler
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header className="header">
        <div className="navbar-header">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-6 col-sm-6 col-6">
              <div className="header-fltr">
                <Link className="toggle fs-4" onClick={removeClass}>
                  <i className="fa fa-bars" />
                </Link>
              </div>
            </div>

            {/* ✅ Right side only logout button */}
            <div className="col-lg-7 col-md-6 col-sm-6 col-6 d-flex justify-content-end">
              <button
                onClick={handleLogout}
                className="btn btn-danger text-white"
              >
                <i className="fa fa-sign-out me-1" />
                LogOut
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

